import Vue from 'vue';
import App from './App';
import RouterConfig from './router';
import StoreConfig from './store';

import Fundation from 'fundation-app-vuejs';
import {Router, Store} from 'fundation-app-vuejs';
import metaDefinition from './store/meta';
import Icon from 'vue-awesome/components/Icon';
import 'vue-awesome/icons';

Vue.component('v-icon', Icon);
Vue.use(Fundation);

StoreConfig.metaDefinition = metaDefinition;
StoreConfig.apiRootUrl = window.config.api_root_url;

Vue.config.productionTip = false;

/* eslint-disable no-new */
let app = new Vue({
    el: '#app',
    router: new Router(RouterConfig),
    store: new Store(StoreConfig),
    components: { App },
    template: '<App/>',
});

// pour supprimer le loader 1 une fois fundation chargé
let loading1 = document.querySelector('#loading1');
loading1.parentNode.removeChild(loading1);

window.app = app;



// WEBPACK FOOTER //
// ./src/main.js